var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduction-trigger"},_vm._l((_vm.cardContents),function(cardContent,i){return _c('div',{key:i,staticClass:"trigger-card-wrapper"},[_c('TriggerCard',{staticClass:"trigger-card",scopedSlots:_vm._u([{key:"card-text",fn:function(){return [_vm._v(_vm._s(cardContent.cardText))]},proxy:true},{key:"circle-text",fn:function(){return [_vm._v(_vm._s(cardContent.circleText))]},proxy:true}],null,true)})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d8cdf2f0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LP/organisms/IntroductionTrigger.vue
// module id = null
// module chunks = 